<i
  *ngIf="item[field]?.id"
  class="fas fa-exclamation-triangle"
  [pTooltip]="item[field]?.id | capBaseDataTranslation"
  tooltipPosition="left">
</i>
